
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Get the root element
const rootElement = document.getElementById("root");

// Prevent the white flash by ensuring dark background from the start
if (document.body) {
  document.body.style.backgroundColor = "#0a0a0a";
  document.body.style.color = "#ffffff";
}

// Force refresh meta tags on initial load
const refreshMetaTags = () => {
  console.log("Refreshing meta tags for social sharing...");
  const metaTags = document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]');
  metaTags.forEach(tag => {
    const value = tag.getAttribute('content');
    if (value) {
      const originalValue = value;
      // Force refresh by briefly changing and restoring the value
      tag.setAttribute('content', '');
      setTimeout(() => {
        tag.setAttribute('content', originalValue);
        console.log(`Refreshed tag content: ${originalValue}`);
      }, 10);
    }
  });
};

// Initialize app and refresh meta tags
if (rootElement) {
  createRoot(rootElement).render(<App />);
  // Refresh meta tags after initial render
  setTimeout(refreshMetaTags, 500);
} else {
  console.error("Root element not found");
}
